<mat-form-field [id]="htmlId" class="w-full">
  <span
    (click)="onFieldTypeChange($event)"
    [title]="getActiveFieldType() ? ('castor.field_types.' + getActiveFieldType() | transloco) : ''"
    class="mx-1"
    matSuffix
  >
    <mat-icon class="fill">{{ getActiveFieldIcon() }}</mat-icon>
  </span>

  <span [matMenuTriggerFor]="menu"></span>
  <mat-menu #menu="matMenu">
    @for (associatedField of associatedFields; track associatedField) {
      <button
        (click)="onFieldTypeActivate(associatedField)"
        mat-menu-item
      >
        {{ associatedField.fieldName }}
      </button>
    }
  </mat-menu>

  <mat-label>{{ label || 'castor.field' | transloco }}</mat-label>
  <mat-select [compareWith]="compareFn" [formControl]="control">
    @if (hasGroups()) {
      @for (group of getGroupsOrder(); track group) {
        @if (hasGroupFields(group) && getGroupFields()[group].length > 0) {
          <mat-optgroup
            [label]="'castor.field_select.' + group | transloco"
          >
            @for (field of getGroupFields()[group]; track field) {
              <mat-option [value]="field">
                {{ field.fieldName }}
              </mat-option>
            }
          </mat-optgroup>
        }
      }
      @if (getGroupFields()['other'].length > 0) {
        <mat-optgroup [label]="'castor.field_select.other' | transloco">
          @for (field of getGroupFields()['other']; track field) {
            <mat-option [value]="field">
              {{ field.fieldName }}
            </mat-option>
          }
        </mat-optgroup>
      }
    }

    @if (!hasGroups()) {
      @for (field of getFields(); track field) {
        <mat-option [value]="field">
          {{ field.fieldName }}
        </mat-option>
      }
    }
  </mat-select>

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
